/**
 * @generated SignedSource<<eaa1418a7288327c4342f831ba3d41e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GeoCaseCards_item$data = {
  readonly caseCard: {
    readonly rendered: string | null;
  } | null;
  readonly " $fragmentType": "GeoCaseCards_item";
};
export type GeoCaseCards_item$key = {
  readonly " $data"?: GeoCaseCards_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"GeoCaseCards_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GeoCaseCards_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CaseCard",
      "kind": "LinkedField",
      "name": "caseCard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rendered",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CaseArticle",
  "abstractKey": null
};

(node as any).hash = "e5d857f25c6966dd5fb46f31e4e9511a";

export default node;
